// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"549":"c17a90e3","901":"fa61cd52"}[chunkId] + ".css";
};